//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EVENTS } from '@/scripts/constants/css-classes'
export default {
  name: 'rb-accordion',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    dataElementId: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      isOpen: this.$props.open,
    }
  },
  computed: {
    hasCustomIcon() {
      return this.$slots.icon
    },
  },
  mounted() {
    this.scrollAndOpenSelectedAccordion()
    window.addEventListener(EVENTS.HASHCHANGE, () => {
      this.scrollAndOpenSelectedAccordion()
    })
  },
  beforeDestroy() {
    window.removeEventListener(EVENTS.HASHCHANGE, () => {
      this.scrollAndOpenSelectedAccordion()
    })
  },

  methods: {
    scrollAndOpenSelectedAccordion() {
      if (this.id) {
        const urlId = decodeURI(window.location.hash.replace('#', ''))
        if (urlId && this.id.includes(urlId)) {
          if (this.$parent.$options.name === this.$options.name) {
            this.$parent.isOpen = true
          }
          this.isOpen = true
          this.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        }
      }
    },
    toggleAccordion: function () {
      this.isOpen = !this.isOpen
      this.$emit('clicked', this.isOpen)
    },
  },
}
